import { useEffect } from 'react';

/**
 * Hook for registering keyboard shortcuts
 * @param {Object} shortcuts - Object mapping key combinations to handlers
 * Example: { 'ctrl+s': handleSave, 'ctrl+n': handleNew }
 */
export function useKeyboardShortcuts(shortcuts) {
    useEffect(() => {
        const handleKeyDown = (event) => {
            const key = event.key.toLowerCase();
            const ctrl = event.ctrlKey || event.metaKey; // Support both Ctrl and Cmd (Mac)
            const shift = event.shiftKey;
            const alt = event.altKey;

            // Build the key combination string
            let combination = '';
            if (ctrl) combination += 'ctrl+';
            if (shift) combination += 'shift+';
            if (alt) combination += 'alt+';
            combination += key;

            // Check if this combination has a handler
            if (shortcuts[combination]) {
                event.preventDefault();
                shortcuts[combination](event);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [shortcuts]);
}
